import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthenticationService } from './core/authentication/authentication.service';
import { AlertDialogComponent, ConfirmDialogModel } from './shared/alert-dialog/alert-dialog.component';
import { UserProfileService } from './core/http/user-profile.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'SmthPortal';
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  dialogOpen = false;
  dialogRef;
  authorized = true;
  isIframe = false;
  
  constructor(
    private authenticationService: AuthenticationService, 
    private msalService: MsalService,
    private idle: Idle, private keepalive: Keepalive, 
    private router: Router, 
    private userProfileService: UserProfileService,
    public dialog: MatDialog, private location: Location) 
    {

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(90000);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(59);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.dialogRef.close();
      this.dialogOpen = false;
      this.router.navigate(['/dashboard']);
      this.reset();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      console.log(this.idleState);
      // this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      this.showAlert(this.idleState);
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  ngOnInit(){
    this.isIframe = window !== window.parent && !window.opener;
   
    this.authenticationService.broadcast();
    this.authenticationService.msalLoginSuccess$.subscribe(() => {
    //  debugger;
   //   this.updateUserProfile()
    })
  }

  // updateUserProfile(){
  //   this.userProfileService.getUserDetails()
  //   .subscribe(res => {
  //     console.log('from APP COMP')
  //     if (res != null) {
  //      // console.log('In App Comp:: ', res);
  //       localStorage.setItem('currentUser', JSON.stringify(res));
  //       if (this.location.path() === '/unauthorized') {
  //         console.log("app.component 1 - location.path() === '/unauthorized'")
  //         this.router.navigate(['']);
  //       }
  //     } else {
  //       this.authorized = false;
  //       console.log("app.component 2 - location.path() === '/unauthorized'")
  //       this.router.navigate(['unauthorized']);
  //     }
  //   },
  //     error => {
  //       this.authorized = false;
  //       console.log("app.component 3 - location.path() === '/unauthorized'")
  //       this.router.navigate(['unauthorized']);
  //     }
  //   );
  // }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  showAlert(message) {
    const dialogData = new ConfirmDialogModel('Timeout', message, 'confirmX');
    console.log(message);
    if (!this.dialogOpen) {
      this.dialogRef = this.dialog.open(AlertDialogComponent, {
        height: '250px',
        width: '600px',
        data: dialogData
      });

      this.dialogRef.afterClosed().subscribe(result => {
        this.dialogOpen = false;
      });
    } else {
      if (this.dialogRef && this.dialogRef.componentInstance) {
        this.dialogRef.componentInstance.data = dialogData;
      }
    }
    this.dialogOpen = true;
  }

}
